import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import * as Vivus from "vivus";
import { isTouchDevice, debounce } from '../helpers'

export default class extends Controller {
  static targets = [ "acceptTerms", "update", "product"]
  initialize() {
    this.termsChecked = false
    this.checkoutBtn = this.element.querySelector('.button')

    this.checkoutBtn.classList.add('disabled')
    this.setupCheckboxTl()

    if(this.productTargets){
      this.setupRecommendations()
    }
  }

  setupRecommendations(){
    fetch(window.Shopify.routes.root + "recommendations/products.json?product_id="+this.productTargets[0].getAttribute('data-id')+"&limit=12&intent=related")
    .then(response => response.json())
    .then(({ products }) => {
      console.log(products)
      products.forEach((product)=>{
        var price = parseInt(product.price / 100) + "." + (product.price % 100)

        var html = `<div class="card" data-controller="card" data-action="mouseenter->card#play mouseleave->card#reverse">
          <div class="card-img-wrapper">
            <a class="card-link" href="${product.url}" title="${product.title}">
              <div class="card-img card-img__secondary" data-card-target="secondaryImg">
                <img src="${product.images[1]}" loading="lazy">
                </div>
              <div class="card-img card-img__primary" data-card-target="primaryImg" style="opacity: 1; visibility: inherit;">
                <img src="${product.images[0]}" loading="lazy">
              </div>
            </a>
            <a class="button fs--s button--s" href="/cart/add?id=${product.variants[0].id}">
              <div class="rect top-rect">
                <span class="fs--xs">Add to cart</span>
                <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path d="M13.5 7.5l-4-4m4 4l-4 4m4-4H1" stroke="currentColor"></path></svg>
              </div>
              <div class="rect bottom-rect"></div>
            </a>
          </div>
          <a class="card-link" href="${product.url}" title="${product.title}">
            <header class="card-data" data-card-target="data">
              <div class="card-data-wrapper" data-card-target="title">
                <h4 class="card-title fs--ml">${product.title}</h4>
                <h5 class="fs--xs"><div class="price">${price} ${Shopify.currency.active}</div></h5>
              </div>
            </header>
          </a>
        </div>`;
        document.querySelector('.cards-container__products').insertAdjacentHTML('beforeend', html)
      })
    })

    const headerHTML = `<header class="wrapper">
    <h3 class="fs--l">You might also like</h3>
    <nav>
      <a href="#" class="circle-button disabled" data-action="click->carrousel#scrollPrev" data-carrousel-target="circleBtn">
        <svg class="arrow-left$" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path d="M1.5 7.5l4-4m-4 4l4 4m-4-4H14" stroke="currentColor"></path></svg>
        <svg class="circle" fill="none" height="51" viewBox="0 0 48 51" width="48" xmlns="http://www.w3.org/2000/svg"><path d="m30.9462 2.97653.0035.00132c2.6004.99587 5.0417 2.36562 7.2469 4.06601 1.1194.86441 2.1027 1.89204 2.9168 3.04854 3.9962 5.9045 6.8474 12.8436 6.3248 19.861v-.0001l-.0004.0054c-.2178 3.4182-1.4071 6.7031-3.4279 9.4686-2.0208 2.7654-4.7892 4.8964-7.9796 6.1425l-.0001-.0002-.0129.0054c-5.6977 2.4112-12.1343 5.0431-18.2203 3.5623v-.0001l-.0097-.0022c-5.1825-1.1526-9.76846-4.1515-12.90226-8.4367-2.52166-3.8799-4.015175-8.3374-4.340015-12.9535-.338681-5.8375 1.240255-11.6257 4.496255-16.4826l.00508-.0076.0048-.0077c2.81588-4.55082 7.27874-7.83987 12.45914-9.18222 4.4661-1.081423 9.1568-.7631 13.4359.91185z" stroke="#fff"></path></svg>
      </a>
      <a href="#" class="circle-button" data-action="click->carrousel#scrollNext" data-carrousel-target="circleBtn">
        <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path d="M13.5 7.5l-4-4m4 4l-4 4m4-4H1" stroke="currentColor"></path></svg>
        <svg class="circle" fill="none" height="51" viewBox="0 0 48 51" width="48" xmlns="http://www.w3.org/2000/svg"><path d="m30.9462 2.97653.0035.00132c2.6004.99587 5.0417 2.36562 7.2469 4.06601 1.1194.86441 2.1027 1.89204 2.9168 3.04854 3.9962 5.9045 6.8474 12.8436 6.3248 19.861v-.0001l-.0004.0054c-.2178 3.4182-1.4071 6.7031-3.4279 9.4686-2.0208 2.7654-4.7892 4.8964-7.9796 6.1425l-.0001-.0002-.0129.0054c-5.6977 2.4112-12.1343 5.0431-18.2203 3.5623v-.0001l-.0097-.0022c-5.1825-1.1526-9.76846-4.1515-12.90226-8.4367-2.52166-3.8799-4.015175-8.3374-4.340015-12.9535-.338681-5.8375 1.240255-11.6257 4.496255-16.4826l.00508-.0076.0048-.0077c2.81588-4.55082 7.27874-7.83987 12.45914-9.18222 4.4661-1.081423 9.1568-.7631 13.4359.91185z" stroke="#fff"></path></svg>
      </a>
    </nav>
  </header>`;
    
  document.querySelector('[data-controller="carrousel"]').insertAdjacentHTML('afterbegin', headerHTML)
  }

  setupCheckboxTl(){
    console.log(this.acceptTermsTarget)
    const svg = this.acceptTermsTarget.querySelector('svg')
    this.svgPath = new Vivus(svg,{
      start:'manual'
    })

    this.checkboxTl = gsap.timeline({
      paused: true
    })
    .to(this.acceptTermsTarget.querySelector('label'),{
      yPercent:-100,
      autoAlpha:0,
      duration:.125
    })
    .set(this.acceptTermsTarget.querySelector('label'),{
      yPercent:100
    })
    .to(this.acceptTermsTarget.querySelector('label'),{
      yPercent:0,
      autoAlpha:1,
      duration:.125
    })

  }

  toggleAcceptTerms(event){
    this.termsChecked = event.target.closest('fieldset').querySelector('input').checked

    if(this.termsChecked){
      this.svgPath.stop().reset().play(4);
      this.checkboxTl.play()
      this.checkoutBtn.classList.remove('disabled')
    }else{
      this.checkoutBtn.classList.add('disabled')
      this.svgPath.play(-4)
      this.checkboxTl.reverse()
    }
  }

  increaseAmount(event){
    let amountDiv = event.target.closest('[data-action]').parentElement
    let valInput = amountDiv.querySelector('.amount-value')
    let currentVal = valInput.value
    valInput.value = parseInt(currentVal) + 1
    this.updateAmount()
  }

  decreaseAmount(event){
    let amountDiv = event.target.closest('[data-action]').parentElement
    let valInput = amountDiv.querySelector('.amount-value')
    let currentVal = valInput.value

    if(valInput.value > 0){
      valInput.value = parseInt(currentVal) - 1
      this.updateAmount()
    }
  }


  selectAmount(event){
    event.target.closest('input').select()
  }

  submitAmount(){
    this.updateTarget.click()
  }

  updateAmount = debounce(() => this.submitAmount());

}